"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _input_props = require("./input_props");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isWebkit = !!window.chrome || !!window.safari;

var isNumberStr = function isNumberStr() {
  var numberValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var numberReg = /^[0-9.]*$/gi;

  if (numberReg.test(numberValue)) {
    return true;
  }

  var strValue = "".concat(numberValue);

  if (strValue.slice(0, 1) === '-' && numberReg.test(strValue.slice(1))) {
    return true;
  }

  return false;
};
/**
 * @class
 */


var Input =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Input, _PureComponent);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Input).call(this, props));

    _this.nullList();

    var value = props.value || typeof props.value === 'number' ? props.value : '';
    _this.state = {
      value: value
    }; // 中文输入是否结束了的标记

    _this.isOnComposition = false;
    _this.handleTempChange = _this.handleTempChange.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleTruncate = _this.handleTruncate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var value = nextProps.value || typeof nextProps.value === 'number' ? nextProps.value : '';
      this.setState({
        value: value
      });
      this.isOnComposition = false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.rootNode = null;
    } // 对外提供的方法用于获取内部的dom结构，需要一直支持

  }, {
    key: "getDOMNode",
    value: function getDOMNode() {
      return this.rootNode || null;
    } // 提供聚焦方法

  }, {
    key: "focus",
    value: function focus() {
      this.rootNode && this.rootNode.focus && this.rootNode.focus();
    } // 提供失焦方法

  }, {
    key: "blur",
    value: function blur() {
      this.rootNode && this.rootNode.blur && this.rootNode.blur();
    }
  }, {
    key: "handleTempChange",
    value: function handleTempChange(event) {
      this.setState({
        value: event.target.value || ''
      });
    }
  }, {
    key: "handleTruncate",
    value: function handleTruncate(value) {
      var _this$props = this.props,
          _this$props$value = _this$props.value,
          propsValue = _this$props$value === void 0 ? '' : _this$props$value,
          maxLength = _this$props.maxLength,
          calculateLength = _this$props.calculateLength,
          slice = _this$props.slice,
          truncate = _this$props.truncate;
      var result = value;

      if (maxLength > 0) {
        if ((0, _spauiUtils.isFunction)(truncate)) {
          result = truncate(result, maxLength);
        } else if (calculateLength(result) > calculateLength(propsValue) && calculateLength(result) > maxLength) {
          result = slice(result, maxLength);
        }
      }

      return result;
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          type = _this$props2.type;
      var newEvent = event;
      var oldValue = event.target.value || '';
      var newValue = '';
      var len = 0;
      var triggerChange = true;
      var i = 0;
      var pointCount = 0; // 截取

      newValue = this.handleTruncate(oldValue); // 被截取后两个内容不一样的话，要重新设置下内容

      if (oldValue !== newValue) {
        this.setState({
          value: newValue || ''
        });
        newEvent.target.value = newValue;
      } // 数字类型的话要判断下输入


      if (type === 'number' || type === 'digit') {
        len = newValue.length;

        if (len > 0) {
          for (; i < len; i++) {
            if (newValue[i] === '.') {
              pointCount += 1;
            }
          }

          if (!isNumberStr(newValue) || pointCount >= 2) {
            triggerChange = false;
          }
        }
      }

      if (triggerChange && (0, _spauiUtils.isFunction)(onChange)) {
        var nextValue = onChange(newEvent, newValue); // 某些场景下，中文输入后，内部的 state 已经修改了，
        // 但是外层的 value 一直是同一个值（相当于是强制指定用户哪些值不能输入），
        // 导致没法触发 componentWillReceiveProps 函数，不能同步外层的 value

        if ((0, _spauiUtils.isString)(nextValue) || (0, _spauiUtils.isNumber)(nextValue)) {
          this.setState({
            value: nextValue
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _classNames;

      var _this$props3 = this.props,
          type = _this$props3.type,
          onCompositionStart = _this$props3.onCompositionStart,
          onCompositionUpdate = _this$props3.onCompositionUpdate,
          onCompositionEnd = _this$props3.onCompositionEnd,
          prefix = _this$props3.prefix,
          suffix = _this$props3.suffix;
      var htmlRef = this.props.htmlRef || this.props.htmlref;
      var value = this.state.value;

      var _this$props4 = this.props,
          size = _this$props4.size,
          status = _this$props4.status,
          maxLength = _this$props4.maxLength,
          _this$props4$useCompo = _this$props4.useComponsition,
          useComponsition = _this$props4$useCompo === void 0 ? true : _this$props4$useCompo,
          _this$props4$tagType = _this$props4.tagType,
          tagType = _this$props4$tagType === void 0 ? '' : _this$props4$tagType,
          borderless = _this$props4.borderless,
          underlined = _this$props4.underlined,
          style = _this$props4.style,
          wrapperClassName = _this$props4.wrapperClassName,
          width = _this$props4.width,
          height = _this$props4.height,
          radius = _this$props4.radius,
          onKeyDown = _this$props4.onKeyDown,
          onPressEnter = _this$props4.onPressEnter,
          inputProps = _objectWithoutProperties(_this$props4, ["size", "status", "maxLength", "useComponsition", "tagType", "borderless", "underlined", "style", "wrapperClassName", "width", "height", "radius", "onKeyDown", "onPressEnter"]);

      var Tag = tagType ? tagType : 'input'; // 去掉不需要的参数

      if (_typeof(inputProps) === 'object' && inputProps) {
        delete inputProps.calculateLength;
        delete inputProps.slice;
        delete inputProps.truncate;
        delete inputProps.htmlRef;
        delete inputProps.htmlref;
        delete inputProps.prefix;
        delete inputProps.suffix;
      } // 数字跟字符限制不一样


      if (type === 'number' || type === 'digit') {
        inputProps.maxLength = maxLength;
      } // 处理中文拼音输入


      var handleCommonComponsition = function handleCommonComponsition(e) {
        if (typeof maxLength !== 'undefined' || useComponsition) {
          if (e.type === 'compositionend') {
            // composition is end
            _this2.isOnComposition = false; // fixed for Chrome v53+ and detect all Chrome
            // https://chromium.googlesource.com/chromium/src/
            // +/afce9d93e76f2ff81baaa088a4ea25f67d1a76b3%5E%21/

            var targetIsOk = e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement;

            if (targetIsOk && !_this2.isOnComposition && isWebkit) {
              // fire onChange
              _this2.handleChange(e);
            }
          } else if (isWebkit) {
            // in composition
            _this2.isOnComposition = true;
          }
        }
      };

      var handleCompositionStart = function handleCompositionStart(event) {
        handleCommonComponsition(event);

        if ((0, _spauiUtils.isFunction)(onCompositionStart)) {
          onCompositionStart(event);
        }
      };

      var handleCompositionUpdate = function handleCompositionUpdate(event) {
        handleCommonComponsition(event);

        if ((0, _spauiUtils.isFunction)(onCompositionUpdate)) {
          onCompositionUpdate(event);
        }
      };

      var handleCompositionEnd = function handleCompositionEnd(event) {
        handleCommonComponsition(event);

        if ((0, _spauiUtils.isFunction)(onCompositionEnd)) {
          onCompositionEnd(event);
        }
      };

      var handleChange = function handleChange(e) {
        if (typeof maxLength !== 'undefined' || useComponsition) {
          var isInputElement = e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement; // only when onComposition===false to fire onChange

          if (isInputElement && !_this2.isOnComposition) {
            _this2.handleChange(e);
          } else {
            _this2.handleTempChange(e);
          }
        } else {
          _this2.handleChange(e);
        }
      };

      var handleKeyDown = function handleKeyDown(e) {
        if (e.keyCode === 13 && (0, _spauiUtils.isFunction)(onPressEnter)) {
          onPressEnter(value);
        } else if ((0, _spauiUtils.isFunction)(onKeyDown)) {
          onKeyDown(e);
        }
      };

      var classList = (0, _classnames["default"])('spaui-input', (_classNames = {
        'input-mini': size === 'mini',
        'input-sm': size === 'small',
        'input-lg': size === 'large',
        'input-xlg': size === 'extralarge'
      }, _defineProperty(_classNames, "has-".concat(status), status), _defineProperty(_classNames, "borderless", borderless), _defineProperty(_classNames, "underlined", underlined), _classNames));
      var cssText = (0, _spauiUtils.removeUndefined)(_objectSpread({
        width: (0, _spauiUtils.pxVal)(width),
        height: (0, _spauiUtils.pxVal)(height),
        borderRadius: (0, _spauiUtils.pxVal)(radius)
      }, style)); // 以下三种情况，需要加一个 div 包裹

      var isNative = !(prefix || suffix || underlined);

      var dom = _react["default"].createElement(Tag, _extends({}, inputProps, (0, _utils.getDataSet)(inputProps), (0, _spauiUtils.globalProps)(this.props, {
        className: isNative ? classList : 'spaui-input-native',
        supportAllEvents: true
      }, Input), {
        ref: function ref(el) {
          _this2.rootNode = el;

          if ((0, _spauiUtils.isFunction)(htmlRef)) {
            htmlRef(el);
          }
        },
        value: value,
        onCompositionStart: handleCompositionStart,
        onCompositionUpdate: handleCompositionUpdate,
        onCompositionEnd: handleCompositionEnd,
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        style: isNative ? cssText : null
      }));

      if (prefix || suffix || underlined) {
        return _react["default"].createElement("div", {
          style: !isNative ? cssText : null,
          className: (0, _classnames["default"])('spaui-input-mixed', wrapperClassName, _defineProperty({
            disabled: inputProps.disabled
          }, classList, !isNative))
        }, prefix ? _react["default"].createElement("span", {
          className: "spaui-input-prefix"
        }, prefix) : null, dom, suffix ? _react["default"].createElement("span", {
          className: "spaui-input-suffix"
        }, suffix) : null);
      }

      return dom;
    }
  }]);

  return Input;
}(_react.PureComponent); // 组件标记


_defineProperty(Input, "propTypes", _input_props.propTypes);

_defineProperty(Input, "defaultProps", _input_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Input, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Input;
exports["default"] = _default;